import React, { Component } from 'react';
import {
    Box,
    Typography,
    Avatar,
    Paper,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
    Divider,
    Button,
    Switch,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    CardActionArea
} from '@mui/material';
import {
    Person,
    LocationOn,
    Payment,
    Notifications,
    Security,
    HelpOutline,
    ExitToApp,
    ChevronRight,
    Edit,
    ShoppingBag,
    Favorite,
    ArrowBack,
    PhotoCamera,
    CreditCard,
    HeadsetMic
} from '@mui/icons-material';
import { WithRouter } from '../../comp/WithRouter';

class PerfilPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            usuario: {
                nome: 'Carlos Silva',
                email: 'carlos.silva@email.com',
                telefone: '(11) 98765-4321',
                foto: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150'
            },
            notificacoesPush: true,
            modalEditarAberto: false,
            formEditar: {
                nome: 'Carlos Silva',
                email: 'carlos.silva@email.com',
                telefone: '(11) 98765-4321'
            }
        };
    }

    // Voltar para a página anterior
    handleVoltar = () => {
        if (this.props.navigate) {
            this.props.navigate(-1);
        }
    };

    // Modal de Edição
    handleAbrirModal = () => {
        this.setState({
            modalEditarAberto: true,
            formEditar: { ...this.state.usuario }
        });
    };

    handleFecharModal = () => {
        this.setState({ modalEditarAberto: false });
    };

    handleInputChange = (campo, valor) => {
        this.setState((prevState) => ({
            formEditar: {
                ...prevState.formEditar,
                [campo]: valor
            }
        }));
    };

    handleSalvarPerfil = () => {
        this.setState((prevState) => ({
            usuario: {
                ...prevState.usuario,
                ...prevState.formEditar
            },
            modalEditarAberto: false
        }));
    };

    handleToggleNotificacoes = (e) => {
        this.setState({ notificacoesPush: e.target.checked });
    };

    handleLogout = () => {
        if (this.props.navigate) {
            this.props.navigate('/auth/login/hub');
        }
    };

    render() {
        const { usuario, notificacoesPush, modalEditarAberto, formEditar } = this.state;
        const { navigate } = this.props;

        return (
            <Box
                sx={{
                    bgcolor: '#f4f5f7',
                    minHeight: '100vh',
                    pb: 12,
                    maxWidth: '480px',
                    mx: 'auto',
                    position: 'relative'
                }}
            >
                {/* CABEÇALHO COM BOTÃO VOLTAR E PERFIL */}
                <Box
                    sx={{
                        background: 'linear-gradient(135deg, #562dab 0%, #3e1b85 100%)',
                        color: '#fff',
                        pt: 2,
                        pb: 5,
                        px: 2.5,
                        borderBottomLeftRadius: '28px',
                        borderBottomRightRadius: '28px',
                        position: 'relative',
                        boxShadow: '0 8px 24px rgba(86, 45, 171, 0.25)'
                    }}
                >
                    {/* BARRA SUPERIOR DE NAVEGAÇÃO */}
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                        <IconButton
                            onClick={this.handleVoltar}
                            sx={{
                                color: '#fff',
                                bgcolor: 'rgba(255, 255, 255, 0.15)',
                                '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.25)' },
                                backdropFilter: 'blur(4px)'
                            }}
                        >
                            <ArrowBack />
                        </IconButton>
                        <Typography variant="subtitle1" sx={{ fontWeight: 800, letterSpacing: '0.5px' }}>
                            Meu Perfil
                        </Typography>
                        <IconButton
                            onClick={this.handleAbrirModal}
                            sx={{
                                color: '#fff',
                                bgcolor: 'rgba(255, 255, 255, 0.15)',
                                '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.25)' },
                                backdropFilter: 'blur(4px)'
                            }}
                        >
                            <Edit fontSize="small" />
                        </IconButton>
                    </Box>

                    {/* FOTO E IDENTIFICAÇÃO DO USUÁRIO */}
                    <Box sx={{ textAlign: 'center', mt: 1 }}>
                        <Box sx={{ position: 'relative', display: 'inline-block' }}>
                            <Avatar
                                src={usuario.foto}
                                sx={{
                                    width: 90,
                                    height: 90,
                                    mx: 'auto',
                                    border: '3px solid #fff',
                                    boxShadow: '0 6px 18px rgba(0,0,0,0.2)'
                                }}
                            />
                            <IconButton
                                size="small"
                                onClick={this.handleAbrirModal}
                                sx={{
                                    position: 'absolute',
                                    bottom: 2,
                                    right: -2,
                                    bgcolor: '#ffb142',
                                    color: '#fff',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                    '&:hover': { bgcolor: '#ffa502' }
                                }}
                            >
                                <PhotoCamera sx={{ fontSize: 16 }} />
                            </IconButton>
                        </Box>

                        <Typography variant="h6" sx={{ fontWeight: 800, mt: 1.5, lineHeight: 1.2, fontSize: '1.25rem' }}>
                            {usuario.nome}
                        </Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '13px', display: 'block', mt: 0.5 }}>
                            {usuario.email}
                        </Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.65)', fontSize: '12px' }}>
                            {usuario.telefone}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ px: 2, mt: -3 }}>
                    {/* CARDS DE RESUMO / ATALHOS RÁPIDOS */}
                    <Paper
                        elevation={0}
                        sx={{
                            p: 1.5,
                            borderRadius: '20px',
                            display: 'flex',
                            justify: 'space-around',
                            alignItems: 'center',
                            mb: 3,
                            boxShadow: '0 10px 25px rgba(0,0,0,0.05)',
                            bgcolor: '#fff'
                        }}
                    >
                        <CardActionArea
                            onClick={() => navigate && navigate('/pedidos')}
                            sx={{ borderRadius: '14px', p: 1, textAlign: 'center' }}
                        >
                            <Box sx={{ bgcolor: 'rgba(86, 45, 171, 0.1)', borderRadius: '12px', p: 1, display: 'inline-flex', mb: 0.5 }}>
                                <ShoppingBag sx={{ color: '#562dab', fontSize: 22 }} />
                            </Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
                                12
                            </Typography>
                            <Typography variant="caption" sx={{ color: '#747d8c', fontWeight: 600, fontSize: '11px' }}>
                                Meus Pedidos
                            </Typography>
                        </CardActionArea>

                        <Divider orientation="vertical" flexItem sx={{ my: 1 }} />

                        <CardActionArea
                            onClick={() => navigate && navigate('/favoritos')}
                            sx={{ borderRadius: '14px', p: 1, textAlign: 'center' }}
                        >
                            <Box sx={{ bgcolor: 'rgba(255, 71, 87, 0.1)', borderRadius: '12px', p: 1, display: 'inline-flex', mb: 0.5 }}>
                                <Favorite sx={{ color: '#ff4757', fontSize: 22 }} />
                            </Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
                                5
                            </Typography>
                            <Typography variant="caption" sx={{ color: '#747d8c', fontWeight: 600, fontSize: '11px' }}>
                                Favoritos
                            </Typography>
                        </CardActionArea>
                    </Paper>

                    {/* SEÇÃO 1: CONTA E DADOS */}
                    <Typography variant="caption" sx={{ fontWeight: 800, color: '#a4b0be', ml: 1, letterSpacing: '0.8px', textTransform: 'uppercase' }}>
                        Minha Conta
                    </Typography>
                    <Paper elevation={0} sx={{ borderRadius: '18px', mb: 2.5, overflow: 'hidden', border: '1px solid #eef0f3', boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                        <List disablePadding>
                            <ListItem button onClick={this.handleAbrirModal} sx={{ py: 1.5 }}>
                                <ListItemIcon sx={{ color: '#562dab', minWidth: 42 }}>
                                    <Person />
                                </ListItemIcon>
                                <ListItemText
                                    primary={<Typography variant="body2" sx={{ fontWeight: 700, color: '#2f3542' }}>Dados Pessoais</Typography>}
                                    secondary={<Typography variant="caption" sx={{ color: '#a4b0be' }}>Alterar nome, e-mail e telefone</Typography>}
                                />
                                <ChevronRight sx={{ color: '#dcdde1' }} />
                            </ListItem>

                            <Divider component="li" />

                            <ListItem button onClick={() => navigate && navigate('/enderecos')} sx={{ py: 1.5 }}>
                                <ListItemIcon sx={{ color: '#562dab', minWidth: 42 }}>
                                    <LocationOn />
                                </ListItemIcon>
                                <ListItemText
                                    primary={<Typography variant="body2" sx={{ fontWeight: 700, color: '#2f3542' }}>Meus Endereços</Typography>}
                                    secondary={<Typography variant="caption" sx={{ color: '#a4b0be' }}>Gerenciar locais de entrega</Typography>}
                                />
                                <ChevronRight sx={{ color: '#dcdde1' }} />
                            </ListItem>

                            <Divider component="li" />

                            <ListItem button onClick={() => navigate && navigate('/cartoes')} sx={{ py: 1.5 }}>
                                <ListItemIcon sx={{ color: '#562dab', minWidth: 42 }}>
                                    <CreditCard />
                                </ListItemIcon>
                                <ListItemText
                                    primary={<Typography variant="body2" sx={{ fontWeight: 700, color: '#2f3542' }}>Formas de Pagamento</Typography>}
                                    secondary={<Typography variant="caption" sx={{ color: '#a4b0be' }}>Cartões de crédito e PIX</Typography>}
                                />
                                <ChevronRight sx={{ color: '#dcdde1' }} />
                            </ListItem>
                        </List>
                    </Paper>

                    {/* SEÇÃO 2: CONFIGURAÇÕES */}
                    <Typography variant="caption" sx={{ fontWeight: 800, color: '#a4b0be', ml: 1, letterSpacing: '0.8px', textTransform: 'uppercase' }}>
                        Preferências
                    </Typography>
                    <Paper elevation={0} sx={{ borderRadius: '18px', mb: 2.5, overflow: 'hidden', border: '1px solid #eef0f3', boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                        <List disablePadding>
                            <ListItem sx={{ py: 1.2 }}>
                                <ListItemIcon sx={{ color: '#562dab', minWidth: 42 }}>
                                    <Notifications />
                                </ListItemIcon>
                                <ListItemText
                                    primary={<Typography variant="body2" sx={{ fontWeight: 700, color: '#2f3542' }}>Notificações Push</Typography>}
                                    secondary={<Typography variant="caption" sx={{ color: '#a4b0be' }}>Alertas de ofertas e status do pedido</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <Switch
                                        edge="end"
                                        checked={notificacoesPush}
                                        onChange={this.handleToggleNotificacoes}
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': { color: '#562dab' },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#562dab' }
                                        }}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>

                            <Divider component="li" />

                            <ListItem button onClick={() => navigate && navigate('/seguranca')} sx={{ py: 1.5 }}>
                                <ListItemIcon sx={{ color: '#562dab', minWidth: 42 }}>
                                    <Security />
                                </ListItemIcon>
                                <ListItemText
                                    primary={<Typography variant="body2" sx={{ fontWeight: 700, color: '#2f3542' }}>Segurança e Senha</Typography>}
                                    secondary={<Typography variant="caption" sx={{ color: '#a4b0be' }}>Alterar senha de acesso</Typography>}
                                />
                                <ChevronRight sx={{ color: '#dcdde1' }} />
                            </ListItem>
                        </List>
                    </Paper>

                    {/* SEÇÃO 3: AJUDA */}
                    <Typography variant="caption" sx={{ fontWeight: 800, color: '#a4b0be', ml: 1, letterSpacing: '0.8px', textTransform: 'uppercase' }}>
                        Suporte
                    </Typography>
                    <Paper elevation={0} sx={{ borderRadius: '18px', mb: 3, overflow: 'hidden', border: '1px solid #eef0f3', boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                        <List disablePadding>
                            <ListItem button onClick={() => navigate && navigate('/ajuda')} sx={{ py: 1.5 }}>
                                <ListItemIcon sx={{ color: '#562dab', minWidth: 42 }}>
                                    <HeadsetMic />
                                </ListItemIcon>
                                <ListItemText
                                    primary={<Typography variant="body2" sx={{ fontWeight: 700, color: '#2f3542' }}>Central de Ajuda</Typography>}
                                    secondary={<Typography variant="caption" sx={{ color: '#a4b0be' }}>Dúvidas frequentes e WhatsApp</Typography>}
                                />
                                <ChevronRight sx={{ color: '#dcdde1' }} />
                            </ListItem>
                        </List>
                    </Paper>

                    {/* BOTÃO SAIR */}
                    <Button
                        fullWidth
                        variant="outlined"
                        color="error"
                        startIcon={<ExitToApp />}
                        onClick={this.handleLogout}
                        sx={{
                            borderRadius: '16px',
                            py: 1.4,
                            fontWeight: 800,
                            textTransform: 'none',
                            borderColor: '#ff4757',
                            color: '#ff4757',
                            bgcolor: '#fff',
                            boxShadow: '0 2px 8px rgba(255, 71, 87, 0.08)',
                            '&:hover': { bgcolor: '#fff0f2', borderColor: '#ff4757' }
                        }}
                    >
                        Sair da Conta
                    </Button>

                    <Typography variant="caption" sx={{ display: 'block', textAlign: 'center', mt: 2.5, color: '#a4b0be', fontWeight: 600 }}>
                        FazPedido Hub • Versão 1.0.4
                    </Typography>
                </Box>

                {/* MODAL EDITAR PERFIL */}
                <Dialog
                    open={modalEditarAberto}
                    onClose={this.handleFecharModal}
                    fullWidth
                    PaperProps={{ sx: { borderRadius: '24px', p: 1 } }}
                >
                    <DialogTitle sx={{ fontWeight: 800, fontSize: '18px', pb: 1 }}>
                        Editar Perfil
                    </DialogTitle>
                    <DialogContent>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                            <TextField
                                label="Nome Completo"
                                fullWidth
                                variant="outlined"
                                size="small"
                                value={formEditar.nome}
                                onChange={(e) => this.handleInputChange('nome', e.target.value)}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                            />
                            <TextField
                                label="E-mail"
                                fullWidth
                                variant="outlined"
                                size="small"
                                value={formEditar.email}
                                onChange={(e) => this.handleInputChange('email', e.target.value)}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                            />
                            <TextField
                                label="Telefone / WhatsApp"
                                fullWidth
                                variant="outlined"
                                size="small"
                                value={formEditar.telefone}
                                onChange={(e) => this.handleInputChange('telefone', e.target.value)}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button onClick={this.handleFecharModal} sx={{ color: '#747d8c', fontWeight: 700 }}>
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={this.handleSalvarPerfil}
                            sx={{ bgcolor: '#562dab', fontWeight: 800, borderRadius: '12px', px: 3, '&:hover': { bgcolor: '#45228d' } }}
                        >
                            Salvar
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        );
    }
}

export default WithRouter(PerfilPage);